import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

export async function GetProtocols({
  questionnaire,
  author,
}: any) {
  const url = `${endpoints.ADMFHIR}/QuestionnaireResponse?&author=Organization/${author}&_count=150`;

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 8000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetAdminQuestionnaireResponse: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetAdminQuestionnaireResponse ", error);
      // toast.error(
      //   `GetAdminQuestionnaireResponse Error: ${error?.response?.status}`
      // );
      throw new Error();
    });
  if (response) return response;
}
